import { render, staticRenderFns } from "./Tesoreria.vue?vue&type=template&id=42264447&"
import script from "./Tesoreria.vue?vue&type=script&lang=js&"
export * from "./Tesoreria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports